import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            fromDate: null,
            isDateError: null,
            currentDate: null,
            isLoading: true,
            query: '?status=INITIAL&status=ACCEPTED&status=DECLINED&status=ASSIGNED&status=PICKED_UP&status=REQUESTED&status=APPROVED',
            orders: [],
            activeOrders: [],
            drivers: [],
            couriersActiveCount: new Map(),
            couriersActiveOrders: new Map(),
            couriersFinishCount: new Map(),

        }
    },
    computed: {
        filteredOrders() {
            return this.orders.filter(item => {
                const timeDiff = item.timestamp + (item.preparationTime * 60000) - Date.now();
                console.log(timeDiff + " - " + (30 * 60 * 1000))
                if(timeDiff > (30 * 60 * 1000)) return false;
                return true;
            });
        }
    },
    methods: {
        getOrders: getOrders,
        loadDrivers: loadDrivers,
        generateCouriersCount: generateCouriersCount,
        compareActive(a, b) {
            let aTime = a.timestamp + (a.preparationTime * 60000);
            let bTime = b.timestamp + (b.preparationTime * 60000);
            if (aTime > bTime)
                return -1;
            if (aTime < bTime)
                return 1;
            return 0;
        },

        compareFinished(a, b) {
            let aTime = a.deliveredTime == null ? 0 : a.deliveredTime;
            let bTime = b.deliveredTime == null ? 0 : b.deliveredTime;
            if (aTime > bTime)
                return -1;
            if (aTime < bTime)
                return 1;
            return 0;
        },
        compareActiveDrivers(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrdersDrivers(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },
    },


    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }

        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.currentDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.getOrders();
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0) {
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function getOrders() {
    var _self = this;
    var calendarTimestamp = Date.parse(_self.fromDate);
    if (isNaN(calendarTimestamp)) {
        if (_self.isDateError == null) {
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    _self.isDateError = null
    var timestamp = "&timestamp=" + calendarTimestamp;
    AdminApiService.getOrders(_self.query, timestamp)
        .then((response) => {
            _self.orders = response.data;
            _self.activeOrders = response.data.filter(item => item.status === "INITIAL" || item.status === "REQUESTED" || item.status === "ACCEPTED" || item.status === "DECLINED" || item.status === "PICKED_UP" || item.status === "ASSIGNED" || item.status === "APPROVED")

            _self.generateCouriersCount(_self.activeOrders);
            // _self.generateCouriersFinishedCount(_self.finishedOrders);
            _self.loadDrivers();

        })
        .catch((error) => {
            _self.isLoadingTabOrder = false;
            swal('Greška', error.data.message, 'error')
        })
}


function loadDrivers(){
    var _self = this;
    var activeParams = "?active=true";
    AdminApiService.getDrivers(activeParams)
        .then((response) => {
            _self.drivers = []
            _self.drivers = response.data.map(e => {
                let activeOrders = _self.couriersActiveCount.get(e.id) != null ? _self.couriersActiveCount.get(e.id) : 0;
                let activeOrdersIds = _self.couriersActiveOrders.get(e.id) != null ? _self.couriersActiveOrders.get(e.id) : [];
                // let finishedOrders = _self.couriersFinishCount.get(e.id) != null ? _self.couriersFinishCount.get(e.id) : 0;
                return {
                    id: e.id,
                    name: e.lastName,
                    username: e.username,
                    active: e.active,
                    position: e.position,
                    // isOpenShift: _self.openScheduleCourier.includes(e.id),
                    activeOrders: activeOrders,
                    activeOrdersIds: activeOrdersIds,
                    // finishedOrders: finishedOrders,
                    lastAddress: e.lastDeliveredAddress != null && e.lastDeliveredAddress.street != null && activeOrders === 0 ? e.lastDeliveredAddress.street : ""
                }
            }).sort((a,b) => _self.compareActiveDrivers(a,b)).sort((a,b) => _self.compareOrdersDrivers(a,b))
            _self.isLoading = false;
        })
        .catch((error) => {
            console.log(error);
            // swal('Greška', error.data.localized_error_message, 'error')
        })
}

function generateCouriersCount(activeOrders){
    let _self = this;
    let courierMap = new Map()
    let courierActiveOrderMap = new Map()
    var i = 0;
    for(i =0; i < activeOrders.length; i++){
        if(activeOrders[i].courier != null){
            var courierId = activeOrders[i].courier.id;
            if(courierMap.has(courierId)){
                var currentCount = courierMap.get(courierId);
                var curentItem = courierActiveOrderMap.get(courierId);
                courierMap.set(courierId, currentCount + 1)
                curentItem.push(activeOrders[i].id)
                courierActiveOrderMap.set(courierId, curentItem)
            }else{
                courierActiveOrderMap.set(courierId, [activeOrders[i].id])
                courierMap.set(courierId, 1);
            }
        }
    }
    _self.couriersActiveOrders = courierActiveOrderMap;
    _self.couriersActiveCount = courierMap;
}


// WEBPACK FOOTER //
// ./src/components/TestAI/TestAI.js